var React = require('react');

function RefreshIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 40c7.81 0 14.314-5.597 15.719-13h4.057C42.328 36.624 34.026 44 24 44 13.63 44 5.103 36.107 4.099 26.001h4.025C9.108 33.893 15.84 40 24 40zm0-36c10.71 0 19.455 8.42 19.975 19H39.97C39.453 14.63 32.501 8 24 8 15.842 8 9.109 14.107 8.125 22H4.099c1.003-10.107 9.53-18 19.9-18z","fill":"#8D6CFF","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 22H0L3 7l13 15zM32 27h16l-3 16-13-16z","fill":"#8D6CFF","key":1})]);
}

RefreshIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = RefreshIcon;

RefreshIcon.default = RefreshIcon;
